import { useEffect, useState } from 'react';
import { getRedirectUrl } from '../common/layout/handle-redirection';
export const useLayout = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [redirectUrl, setRedirectUrl] = useState(null);
    const [searchParams, setSearchParams] = useState('');
    const [isPrivateAccount, setIsPrivateAccount] = useState(false);
    useEffect(() => {
        const loadRedirectUrl = async () => {
            const { url = null, searchParams = '', isPrivateCustomer = false, } = await getRedirectUrl();
            setSearchParams(searchParams);
            setRedirectUrl(url);
            setIsPrivateAccount(isPrivateCustomer);
            setIsLoading(false);
        };
        loadRedirectUrl();
    }, []);
    return { isLoading, redirectUrl, searchParams, isPrivateAccount };
};
